
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHamburgerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 30,
  height: 22,
  textRendering: "geometricPrecision",
  viewBox: "0 0 30 22"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAMAAADgvdz9AAAAqFBMVEV0d3nq6uvq6+vIycnh4uKGiYqPkZPz8/Py8vK+v8CGiIqPkpPh4eHHyMjHyMnr6+uDhoh1eHqYmpuRlJWXmZrT1NTY2Nnd3d18f4Dh4eKVl5nu7u7X19h/goPv7/DW19jc3d3T09Td3t7Cw8SkpqimqKmQkpOQkpTr6+zFxseipKWfoaLn5+iSlJaMj5C6u7ymp6np6emho6WNj5GcnqDDxcXm5uebnZ56KjaQAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAmklEQVR42qXPtxrCMAwE4AMSLHAqvYfee33/N4PIixmsJf90990iYbta61zV0FbR1xuWENyxkeYzFtJ8AWU1p5kCkWJk2OUXCs9xmZWYnWNS6Cbuw5MOGtJjA7SkuYnR2L322lATL8j1PcY5MNkbEqwv/l4yueBM0wqLwlxkSmjKXGGXui9PXzhJfz+wl+Ynjge/znxmZ//z/gJ8Hw+VKHE7swAAAABJRU5ErkJggg==",
  width: 30,
  height: 22,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAMAAADgvdz9AAAAqFBMVEV0d3nq6uvq6+vIycnh4uKGiYqPkZPz8/Py8vK+v8CGiIqPkpPh4eHHyMjHyMnr6+uDhoh1eHqYmpuRlJWXmZrT1NTY2Nnd3d18f4Dh4eKVl5nu7u7X19h/goPv7/DW19jc3d3T09Td3t7Cw8SkpqimqKmQkpOQkpTr6+zFxseipKWfoaLn5+iSlJaMj5C6u7ymp6np6emho6WNj5GcnqDDxcXm5uebnZ56KjaQAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAmklEQVR42qXPtxrCMAwE4AMSLHAqvYfee33/N4PIixmsJf90990iYbta61zV0FbR1xuWENyxkeYzFtJ8AWU1p5kCkWJk2OUXCs9xmZWYnWNS6Cbuw5MOGtJjA7SkuYnR2L322lATL8j1PcY5MNkbEqwv/l4yueBM0wqLwlxkSmjKXGGXui9PXzhJfz+wl+Ynjge/znxmZ//z/gJ8Hw+VKHE7swAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"22\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 30 22\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAMAAADgvdz9AAAAqFBMVEV0d3nq6uvq6+vIycnh4uKGiYqPkZPz8/Py8vK+v8CGiIqPkpPh4eHHyMjHyMnr6+uDhoh1eHqYmpuRlJWXmZrT1NTY2Nnd3d18f4Dh4eKVl5nu7u7X19h/goPv7/DW19jc3d3T09Td3t7Cw8SkpqimqKmQkpOQkpTr6+zFxseipKWfoaLn5+iSlJaMj5C6u7ymp6np6emho6WNj5GcnqDDxcXm5uebnZ56KjaQAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAmklEQVR42qXPtxrCMAwE4AMSLHAqvYfee33/N4PIixmsJf90990iYbta61zV0FbR1xuWENyxkeYzFtJ8AWU1p5kCkWJk2OUXCs9xmZWYnWNS6Cbuw5MOGtJjA7SkuYnR2L322lATL8j1PcY5MNkbEqwv/l4yueBM0wqLwlxkSmjKXGGXui9PXzhJfz+wl+Ynjge/znxmZ//z/gJ8Hw+VKHE7swAAAABJRU5ErkJggg==\" width=\"30\" height=\"22\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAMAAADgvdz9AAAAqFBMVEV0d3nq6uvq6+vIycnh4uKGiYqPkZPz8/Py8vK+v8CGiIqPkpPh4eHHyMjHyMnr6+uDhoh1eHqYmpuRlJWXmZrT1NTY2Nnd3d18f4Dh4eKVl5nu7u7X19h/goPv7/DW19jc3d3T09Td3t7Cw8SkpqimqKmQkpOQkpTr6+zFxseipKWfoaLn5+iSlJaMj5C6u7ymp6np6emho6WNj5GcnqDDxcXm5uebnZ56KjaQAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAmklEQVR42qXPtxrCMAwE4AMSLHAqvYfee33/N4PIixmsJf90990iYbta61zV0FbR1xuWENyxkeYzFtJ8AWU1p5kCkWJk2OUXCs9xmZWYnWNS6Cbuw5MOGtJjA7SkuYnR2L322lATL8j1PcY5MNkbEqwv/l4yueBM0wqLwlxkSmjKXGGXui9PXzhJfz+wl+Ynjge/znxmZ//z/gJ8Hw+VKHE7swAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/hamburger-icon.614f6474a98fe976b54b6e3ef1f39c6d.svg"),
        {
          React: SvgHamburgerIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      